import i18next from "i18next";

import { createColumn } from "../../../../components/Table";

export const desktopTableColumns = [
  createColumn({
    keyName: "tags",
    header: () => i18next.t("patientPage_columns_tags"),
    cell: (info) => info.renderValue(),
    size: 150,
  }),
  createColumn({
    keyName: "date",
    header: () => i18next.t("patientPage_columns_date"),
    cell: (info) => info.renderValue(),
    size: 100,
  }),
  createColumn({
    keyName: "notes",
    header: () => i18next.t("patientPage_columns_text"),
    cell: (info) => info.renderValue(),
    size: 250,
  }),
];
